import { render } from "./AcetatorVinegar.vue?vue&type=template&id=189e926f"
const script = {}

import exportComponent from "/Users/sopanshewale/fyra-clients/alphatech/node_modules/vue-loader-v16/dist/exportHelper.js"
export default /*#__PURE__*/exportComponent(script, [['render',render]])